export default __webpack_public_path__ + "static/media/shortStoryIcon.57a151be.svg";